export const translations = {
  fr: {
    title: "Signaler la haine en ligne",
    name: "Nom",
    email: "Email",
    date: "Date du propos",
    type: "Type de propos",
    public: "Public",
    private: "Message privé",
    platform: "Plateforme",
    otherPlatform: "Précisez la plateforme",
    link: "Lien vers le contenu",
    description: "Description",
    screenshot: "Capture d'écran",
    submit: "Envoyer le signalement",
    addImages: "Fournir un lien ou une capture d'écran",
    optional: "Optionnel",
    platformPlaceholder: "Si vous le souhaitez, précisez la plateforme",
    mediaPlaceholder: "Précisez le nom du média",
    descriptionPlaceholder: "Décrivez le contenu et faites un copier-coller...",
    linkPlaceholder: "Fournir un lien ou une capture d'écran",
    imageSelected: "image sélectionnée",
    imagesSelected: "images sélectionnées",
    validationMessage: "Veuillez fournir soit un lien vers le propos, soit une capture d'écran",
    successMessage: "Signalement envoyé avec succès !",
    errorMessage: "Une erreur s'est produite lors de l'envoi du signalement.",
    other: "Autre",
    uploading: "Envoi en cours...",
    thankYou: "Merci de votre signalement",
    reportDetails: "Détails du signalement",
    returnToForm: "Retour sur la page de signalement",
    specifyMedia: "Précisez le média"
  },
  en: {
    title: "Report Online Hate",
    name: "Name",
    email: "Email",
    date: "Date of incident",
    type: "Type of content",
    public: "Public",
    private: "Private message",
    platform: "Platform",
    otherPlatform: "Specify platform",
    link: "Link to content",
    description: "Description",
    screenshot: "Screenshot",
    submit: "Submit report",
    addImages: "Provide a link or screenshot",
    optional: "Optional",
    platformPlaceholder: "If you wish, specify the platform",
    mediaPlaceholder: "Specify the media name",
    descriptionPlaceholder: "Describe the content and paste it here...",
    linkPlaceholder: "Provide a link or screenshot",
    imageSelected: "image selected",
    imagesSelected: "images selected",
    validationMessage: "Please provide either a link to the content or a screenshot",
    successMessage: "Report submitted successfully!",
    errorMessage: "An error occurred while submitting the report.",
    other: "Other",
    uploading: "Uploading...",
    thankYou: "Thank you for your report",
    reportDetails: "Report details",
    returnToForm: "Return to report form",
    specifyMedia: "Specify the media"
  },
  nl: {
    title: "Online haat melden",
    name: "Naam",
    email: "E-mail",
    date: "Datum van incident",
    type: "Type inhoud",
    public: "Openbaar",
    private: "Privébericht",
    platform: "Platform",
    otherPlatform: "Platform specificeren",
    link: "Link naar inhoud",
    description: "Beschrijving",
    screenshot: "Schermafbeelding",
    submit: "Melding verzenden",
    addImages: "Geef een link of schermafbeelding",
    optional: "Optioneel",
    platformPlaceholder: "Indien gewenst, specificeer het platform",
    mediaPlaceholder: "Specificeer de media-naam",
    descriptionPlaceholder: "Beschrijf de inhoud en plak deze hier...",
    linkPlaceholder: "Geef een link of schermafbeelding",
    imageSelected: "afbeelding geselecteerd",
    imagesSelected: "afbeeldingen geselecteerd",
    validationMessage: "Geef een link naar de inhoud of een schermafbeelding",
    successMessage: "Melding succesvol verzonden!",
    errorMessage: "Er is een fout opgetreden bij het verzenden van de melding.",
    other: "Anders",
    uploading: "Uploading...",
    thankYou: "Bedankt voor uw melding",
    reportDetails: "Meldingdetails",
    returnToForm: "Terug naar meldingsformulier",
    specifyMedia: "Specificeer het medium"
  },
  de: {
    title: "Online-Hass melden",
    name: "Name",
    email: "E-Mail",
    date: "Datum des Vorfalls",
    type: "Art des Inhalts",
    public: "Öffentlich",
    private: "Private Nachricht",
    platform: "Plattform",
    otherPlatform: "Plattform angeben",
    link: "Link zum Inhalt",
    description: "Beschreibung",
    screenshot: "Screenshot",
    submit: "Meldung senden",
    addImages: "Link oder Screenshot bereitstellen",
    optional: "Optional",
    platformPlaceholder: "Wenn gewünscht, geben Sie die Plattform an",
    mediaPlaceholder: "Plattform angeben",
    descriptionPlaceholder: "Beschreiben Sie den Inhalt und fügen Sie ihn hier ein...",
    linkPlaceholder: "Link oder Screenshot bereitstellen",
    imageSelected: "Bild ausgewählt",
    imagesSelected: "Bilder ausgewählt",
    validationMessage: "Bitte geben Sie entweder einen Link zum Inhalt oder einen Screenshot an",
    successMessage: "Meldung erfolgreich gesendet!",
    errorMessage: "Beim Senden der Meldung ist ein Fehler aufgetreten.",
    other: "Andere",
    uploading: "Uploading...",
    thankYou: "Vielen Dank für Ihre Meldung",
    reportDetails: "Meldungsdetails",
    returnToForm: "Zurück zur Meldungsseite",
    specifyMedia: "Medium angeben"
  },
  it: {
    title: "Segnala odio online",
    name: "Nome",
    email: "Email",
    date: "Data dell'incidente",
    type: "Tipo di contenuto",
    public: "Pubblico",
    private: "Messaggio privato",
    platform: "Piattaforma",
    otherPlatform: "Specifica piattaforma",
    link: "Link al contenuto",
    description: "Descrizione",
    screenshot: "Screenshot",
    submit: "Invia segnalazione",
    addImages: "Fornisci un link o uno screenshot",
    optional: "Opzionale",
    platformPlaceholder: "Se lo desideri, specifica la piattaforma",
    mediaPlaceholder: "Specifica il nome del media",
    descriptionPlaceholder: "Descrivi il contenuto e incollalo qui...",
    linkPlaceholder: "Fornisci un link o uno screenshot",
    imageSelected: "immagine selezionata",
    imagesSelected: "immagini selezionate",
    validationMessage: "Fornisci un link al contenuto o uno screenshot",
    successMessage: "Segnalazione inviata con successo!",
    errorMessage: "Si è verificato un errore durante l'invio della segnalazione.",
    other: "Altro",
    uploading: "Uploading...",
    thankYou: "Grazie per la segnalazione",
    reportDetails: "Dettagli segnalazione",
    returnToForm: "Torna al modulo segnalazione",
    specifyMedia: "Specifica il media"
  },
  es: {
    title: "Reportar odio en línea",
    name: "Nombre",
    email: "Correo electrónico",
    date: "Fecha del incidente",
    type: "Tipo de contenido",
    public: "Público",
    private: "Mensaje privado",
    platform: "Plataforma",
    otherPlatform: "Especificar plataforma",
    link: "Enlace al contenido",
    description: "Descripción",
    screenshot: "Captura de pantalla",
    submit: "Enviar reporte",
    addImages: "Proporcionar un enlace o captura de pantalla",
    optional: "Opcional",
    platformPlaceholder: "Si lo desea, especifique la plataforma",
    mediaPlaceholder: "Especificar la plataforma",
    descriptionPlaceholder: "Describa el contenido y péguelo aquí...",
    linkPlaceholder: "Proporcionar un enlace o captura de pantalla",
    imageSelected: "imagen seleccionada",
    imagesSelected: "imágenes seleccionadas",
    validationMessage: "Proporcione un enlace al contenido o una captura de pantalla",
    successMessage: "¡Reporte enviado con éxito!",
    errorMessage: "Se produjo un error al enviar el reporte.",
    other: "Otro",
    uploading: "Uploading...",
    thankYou: "Gracias por su informe",
    reportDetails: "Detalles del informe",
    returnToForm: "Regresar al formulario de informe",
    specifyMedia: "Especificar el medio"
  },
  da: {
    title: "Anmeld had på nettet",
    name: "Navn",
    email: "E-mail",
    date: "Dato for hændelsen",
    type: "Type indhold",
    public: "Offentlig",
    private: "Privat besked",
    platform: "Platform",
    otherPlatform: "Angiv platform",
    link: "Link til indhold",
    description: "Beskrivelse",
    screenshot: "Skærmbillede",
    submit: "Send anmeldelse",
    addImages: "Angiv et link eller skærmbillede",
    optional: "Valgfri",
    platformPlaceholder: "Hvis du ønsker det, angiv platformen",
    mediaPlaceholder: "Angiv platformen",
    descriptionPlaceholder: "Beskriv indholdet og indsæt det her...",
    linkPlaceholder: "Angiv et link eller skærmbillede",
    imageSelected: "billede valgt",
    imagesSelected: "billeder valgt",
    validationMessage: "Angiv venligst enten et link til indholdet eller et skærmbillede",
    successMessage: "Anmeldelse sendt med succes!",
    errorMessage: "Der opstod en fejl under afsendelse af anmeldelsen.",
    other: "Anden",
    uploading: "Uploading...",
    thankYou: "Tak for din anmeldelse",
    reportDetails: "Anmeldelsesdetaljer",
    returnToForm: "Tilbage til anmeldelsesformularen",
    specifyMedia: "Angiv mediet"
  },
  tr: {
    title: "Çevrimiçi Nefret Bildirimi",
    name: "İsim",
    email: "E-posta",
    date: "Olay tarihi",
    type: "İçerik türü",
    public: "Herkese açık",
    private: "Özel mesaj",
    platform: "Platform",
    otherPlatform: "Platform belirtin",
    link: "İçerik bağlantısı",
    description: "Açıklama",
    screenshot: "Ekran görüntüsü",
    submit: "Bildirimi gönder",
    addImages: "Bir bağlantı veya ekran görüntüsü sağlayın",
    optional: "İsteğe bağlı",
    platformPlaceholder: "İsterseniz platformu belirtin",
    mediaPlaceholder: "Platform belirtin",
    descriptionPlaceholder: "İçeriği açıklayın ve buraya yapıştırın...",
    linkPlaceholder: "Bir bağlantı veya ekran görüntüsü sağlayın",
    imageSelected: "görüntü seçildi",
    imagesSelected: "görüntü seçildi",
    validationMessage: "Lütfen içeriğe bir bağlantı veya ekran görüntüsü sağlayın",
    successMessage: "Bildirim başarıyla gönderildi!",
    errorMessage: "Bildirim gönderilirken bir hata oluştu.",
    other: "Diğer",
    uploading: "Uploading...",
    thankYou: "Raporunuz için teşekkürler",
    reportDetails: "Rapor detayları",
    returnToForm: "Rapor formuna dön",
    specifyMedia: "Medyayı belirtin"
  },
  ar: {
    title: "الإبلاغ عن خطاب الكراهية عبر الإنترنت",
    name: "الاسم",
    email: "البريد الإلكتروني",
    date: "تاريخ الحادث",
    type: "نوع المحتوى",
    public: "عام",
    private: "رسالة خاصة",
    platform: "المنصة",
    otherPlatform: "تحديد المنصة",
    link: "رابط المحتوى",
    description: "وصف",
    screenshot: "لقطة شاشة",
    submit: "إرسال البلاغ",
    addImages: "قم بتوفير رابط أو لقطة شاشة",
    optional: "اختياري",
    platformPlaceholder: "إذا رغبت، حدد المنصة",
    mediaPlaceholder: "حدد المنصة",
    descriptionPlaceholder: "صف المحتوى والصقه هنا...",
    linkPlaceholder: "قم بتوفير رابط أو لقطة شاشة",
    imageSelected: "صورة محددة",
    imagesSelected: "صور محددة",
    validationMessage: "يرجى تقديم إما رابط للمحتوى أو لقطة شاشة",
    successMessage: "تم إرسال البلاغ بنجاح!",
    errorMessage: "حدث خطأ أثناء إرسال البلاغ.",
    other: "أخرى",
    uploading: "Uploading...",
    thankYou: "شكرا لتقريرك",
    reportDetails: "تفاصيل التقرير",
    returnToForm: "العودة إلى إستمارة التقرير",
    specifyMedia: "حدد وسيلة الإعلام"
  }
}; 